import { useMemo } from 'react';

import { useChatStore } from '@stores/chat.store';
import { useDeviceSize } from '@hooks/device-size';
import { CHAT_CONVERSATION_TYPES, CHAT_USER_TAG, USER_TAG } from '@/utils/constants';

/** Orquestra lógica do header: dados do usuário, flags de exibição. */
export const useHeaderLogic = () => {
	const storeSelectedTabIndex = useChatStore((s) => s.tabs.conversation);
	const conversationActive = useChatStore((s) => s.conversation.active);
	const conversationChatType = useChatStore((s) => s.conversation.chatType);
	const messageListActualLead = useChatStore((s) => s.messageList.actualLead);

	const { isMobile } = useDeviceSize();
	const isDesktop = !isMobile;

	const { name, userTag } = useMemo(() => {
		if (!conversationActive) return { name: false as const, userTag: false as const };
		const conversationType =
			conversationChatType === CHAT_CONVERSATION_TYPES.purchase
				? CHAT_CONVERSATION_TYPES.Sale
				: CHAT_CONVERSATION_TYPES.Purchase;
		const userTagKey = conversationActive.userTag as keyof typeof CHAT_USER_TAG;
		return {
			name: conversationActive[`userName${conversationType}`],
			userTag: CHAT_USER_TAG[userTagKey] ?? false,
		};
	}, [conversationActive, conversationChatType]);

	const isBlocked = conversationActive?.userTag === USER_TAG.Blocked;
	const isSellingTab = storeSelectedTabIndex === 1;
	const isSpam = conversationActive?.userTag === USER_TAG.Spam;

	const isShowUserTag =
		userTag &&
		userTag !== CHAT_USER_TAG.NaturalPerson &&
		!isBlocked &&
		Boolean(storeSelectedTabIndex);
	const showBlockedLabel = isBlocked && isSellingTab;

	return {
		isDesktop,
		isShowUserTag,
		isSellingTab,
		isSpam,
		isBlocked,
		showBlockedLabel,
		name,
		userTag,
		actualLead: messageListActualLead,
	};
};
